import { useState, useEffect } from 'react';

import Table from 'components/generics/Table/ReactTable';
import Button from 'components/generics/Button/Button';
import Modal from 'components/generics/Modal/Modal';
import FormRoute from 'components/pages/parameters/Routes/FormRoute';
import ConfirmDelete from 'components/generics/ConfirmDelete/ConfirmDelete';
import useAuth from 'providers/Auth/useAuth';
import CourseTitle from 'components/generics/CourseTitle/CourseTitle';

import { get as getRoute, bulkDelete as deleteRoute } from 'services/API/Route';

import { prepareTable } from 'utils/func';
import { ROUTE_HEADERS } from 'utils/const';

const Routes = () => {
  const [modalVisibility, setModalVisibility] = useState(false);
  const [formType, setFormtype] = useState(null);
  const [selectedRoute, setSelectedRoute] = useState([]);
  const [data, setData] = useState({ datas: [], headers: [] });
  const [editId, setEditId] = useState(null);
  const [confirmDeletePopup, setConfirmDeletePopup] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    getDatas();
  }, []);

  const getDatas = () => {
    getRoute()
      .then(res => {
        setData({ datas: prepareTable(ROUTE_HEADERS, res.data), headers: ROUTE_HEADERS });
      })
      .catch(e => console.error(e));
  };

  const openModalAdd = e => {
    setFormtype('add');
    setEditId(null);
    setModalVisibility(true);
  };

  const onSubmitForm = () => {
    setModalVisibility(false);
    getDatas();
  };

  const onConfirmDelete = () => {
    if (selectedRoute.length > 0) {
      setConfirmDeletePopup(true);
    }
  };

  const onDelete = () => {
    if (selectedRoute.length > 0) {
      deleteRoute({ ids: selectedRoute.map(v => +v.original.id) })
        .then(e => {
          getDatas();
          setConfirmDeletePopup(false);
        })
        .catch(err => console.error(err));
    }
  };

  const onDeleteRow = () => {
    if (!deleteRow) return;
    deleteRoute({ ids: [+deleteRow.id] })
      .then(() => {
        getDatas();
        setDeleteRow(null);
      })
      .catch(err => console.error(err));
  };

  return (
    <div className="params crud" id="airports">
      <div className="crud__header">
        <div>
          <h1>Routes</h1>
          <h2><CourseTitle /></h2>
        </div>
        <Button
          text="Delete"
          disabled={selectedRoute.length === 0}
          defaultStyle={`primary${selectedRoute.length === 0 ? ' disabled' : ''}`}
          onClick={onConfirmDelete}
        />
        {/* <Button
          text='Export'
          disabled={selectedRoute.length === 0}
          defaultStyle={`primary${selectedRoute.length === 0 ? ' disabled' : ''}`}
          onClick={() => console.log('Export')}
        /> */}
        <Button text="Add route" defaultStyle="primary" onClick={openModalAdd} />
      </div>
      <Table
        selectedRows={d => setSelectedRoute(d)}
        datas={data.datas}
        headers={data.headers}
        editable={false}
        onDelete={row => setDeleteRow(row)}
        name="params/routesFilters"
      />
      {modalVisibility && (
        <Modal onClose={() => setModalVisibility(false)}>
          <FormRoute onSubmit={onSubmitForm} editId={editId} type={formType} />
        </Modal>
      )}
      {confirmDeletePopup && (
        <ConfirmDelete
          onClose={() => setConfirmDeletePopup(false)}
          list={selectedRoute}
          onConfirm={onDelete}
          formatList={data => `Item ${data.label} distance : ${data.distance}`}
        />
      )}
      {deleteRow && (
        <ConfirmDelete
          onClose={() => setDeleteRow(null)}
          list={[deleteRow]}
          onConfirm={onDeleteRow}
          formatList={data => `Route ${data.label} — ${data.distance}`}
        />
      )}
    </div>
  );
};

export default Routes;
